import Architer from 'assets/icons/architer.svg';
import Support from 'assets/icons/support.svg';
import HelpDesk from 'assets/icons/helpDesk.svg';
import Copy from 'assets/icons/copy.svg';
import Audit from 'assets/icons/audit.svg';
import Notes from 'assets/icons/notes.svg';

const gap = { gap: { tablet: '10px', laptop: '20px' } };
const titleProps = { textStyle: { tablet: 'header.h3', laptop: 'h4', desktop: 'header.h4' } };

export const itSupportTechExpertData = {
  title: 'Комплексный подход к ИТ\u2011поддержке',
  titleProps: { maxW: { tablet: '450px', laptop: '700px' } },

  cardsData: [
    {
      title: 'Многоканальное взаимодействие',
      titleProps,
      tabIcon: Architer,
      content:
        'Поддержание бесшовного общения через несколько путей связи для обеспечения удовлетворённости заказчиков и результативности поддержки.',
      description: {
        title: 'Каналы связи:',
        list: [
          'Служба ИТ-помощи (Service desk);',
          'Звонки;',
          'Электронные письма;',
          'Мессенджеры;',
          'Чаты;',
          'Другие удобные для пользователей пути связи.',
        ],
      },
      gap,
    },
    {
      title: 'Помощь через удалённый доступ',
      titleProps,
      tabIcon: Support,
      content:
        'Обеспечение удалённого быстрого доступа к системам клиентов для эффективной диагностики и решения проблем.',
      description: {
        title: 'Ключевые особенности:',
        list: [
          'Быстрое решение проблем;',
          'Безопасный удалённый доступ;',
          'Поддержка и устранение неполадок в реальном времени.',
        ],
      },
      gap,
    },
    {
      title: 'Управление происшествиями',
      titleProps,
      tabIcon: HelpDesk,
      content:
        'Обеспечение эффективного управления и разрешения происшествий для минимизации сбоев и поддержания высокого качества обслуживания.',
      description: {
        title: 'Преимущества:',
        list: [
          'Проактивное обнаружение происшествий;',
          'Быстрый ответ и решение;',
          'Эффективное управление случаями.',
        ],
      },
      gap,
    },
    {
      title: 'Передача и распределение заявок',
      titleProps,
      tabIcon: Copy,
      content:
        'Оптимизация процессов передачи и распределения для обеспечения обработки случаев соответствующими линиями поддержки для быстрого разрешения.',
      description: {
        title: 'Преимущества:',
        list: [
          'Эффективное назначение важности заявок;',
          'Своевременная передача специалистам;',
          'Оптимизированный процесс поддержки.',
        ],
      },
      gap,
    },
    {
      title: 'Систематический разбор заявок',
      titleProps,
      tabIcon: Audit,
      content:
        'Сбор и изучение данных по обращениям для выявления направлений развития и повышения качества обслуживания.',
      description: {
        title: 'Области анализа:',
        list: [
          'Регулярный поиск коренных причин (RCA);',
          'Выявление закономерностей и повторяющихся случаев;',
          'Рекомендации по улучшению сервиса.',
        ],
      },
      gap,
    },
    {
      title: 'Ежемесячная отчетность',
      titleProps,
      tabIcon: Notes,
      content:
        'Создание подробных ежемесячных отчётов для отслеживания результативности поддержки и предоставления сведений по управлению происшествиями.',
      description: {
        title: 'Основные моменты отчёта:',
        list: [
          'Показатели результативности поддержки;',
          'Время разрешения заявок;',
          'Анализ сильных и слабых сторон (SWOT) и рекомендации.',
        ],
      },
      gap,
    },
  ],
};
